import { render, staticRenderFns } from "./MemoEditWindow.vue?vue&type=template&id=07e08b6c&scoped=true"
import script from "./MemoEditWindow.vue?vue&type=script&lang=js"
export * from "./MemoEditWindow.vue?vue&type=script&lang=js"
import style0 from "./MemoEditWindow.vue?vue&type=style&index=0&id=07e08b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e08b6c",
  null
  
)

export default component.exports